import { useState } from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import { CampaignOutlined } from '@mui/icons-material';
import { useWhatsNew } from '../../../../utils/useWhatsNew';
import WhatsNewDialog from './WhatsNewDialog';

const WhatsNewButton = () => {
    const { enabled, notes, unseenIds, markSeen } = useWhatsNew();
    const [open, setOpen] = useState(false);
    // The notes that were unseen at open keep their "New" chip until the dialog closes.
    const [newIds, setNewIds] = useState<string[]>([]);

    if (!enabled) return null;

    const handleOpen = () => {
        setNewIds(unseenIds);
        markSeen();
        setOpen(true);
    };

    const unseenCount = unseenIds.length;
    return (
        <>
            <Tooltip title="What's new">
                <IconButton
                    size="small"
                    onClick={handleOpen}
                    aria-haspopup="dialog"
                    aria-label={unseenCount > 0 ? `What's new (${unseenCount} new)` : "What's new"}
                >
                    <Badge badgeContent={unseenCount} color="primary" max={99}>
                        <CampaignOutlined sx={{ color: '#1e293b' }} />
                    </Badge>
                </IconButton>
            </Tooltip>
            <WhatsNewDialog open={open} notes={notes} newIds={newIds} onClose={() => setOpen(false)} />
        </>
    );
};

export default WhatsNewButton;
